import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import Select from "react-select";

library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [socialLinks, setSocialLinks] = useState([]);
  const [selectedSocials, setSelectedSocials] = useState([]);
  const [socialUrls, setSocialUrls] = useState({});

  const getSocialPlatforms = async () => {
    const response = await getData("/admin/setting/social-link", {});

    if (response?.success) {
      const options =
        response?.data?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];

      setSocialLinks(options);
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/admin/setting/expert-team/${id}`);

    const values = response.data;

    reset({
      name: values.name,
      title: values.title,
      image: values.image,
    });

    const selected = values.social_id.map((item) => ({
      value: item.value,
      label: item.label,
    }));

    setSelectedSocials(selected);

    const urls = {};

    values.social_id.forEach((item) => {
      urls[item.value] = item.social_url;
    });

    setSocialUrls(urls);
  };
  useEffect(() => {
    GetEditData();
    getSocialPlatforms();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();

      finalData.append("name", data.name);
      finalData.append("title", data.title);

      if (data.image?.length) {
        finalData.append("image", data.image[0]);
      }

      const socialIds = selectedSocials.map((item) => item.value);

      finalData.append("social_id", JSON.stringify(socialIds));
      finalData.append("social_url", JSON.stringify(socialUrls));

      const response = await putData(
        `/admin/setting/expert-team/${id}`,
        finalData,
      );

      if (response?.success) {
        setShowModal({
          code: response.code,
          message: response.message,
        });
      } else {
        setShowModal({
          code: response.code,
          message: response.errors,
        });
      }

      setTimeout(() => {
        setShowModal({
          code: 0,
          message: "",
        });

        props.handleClose();
      }, 1000);
    } catch (err) {
      console.log(err);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Expert
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Expert Name</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Expert Name"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Expert Name Is Required",
                            validate: (value) =>
                              value.length <= 200 ||
                              "Data must be 200 characters or less",
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>




              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Title</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="title"
                          placeholder="Title"
                          className={classNames("", {
                            "is-invalid": errors?.title,
                          })}
                          {...register("title", {
                            required: "Title Is Required",
                            validate: (value) =>
                              value.length <= 200 ||
                              "Data must be 200 characters or less",
                          })}
                        />
                      </InputGroup>
                      {errors.title && (
                        <span className="text-danger">
                          {errors.title.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

            

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    <Form.Label className="text-left">Image</Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        type="file"
                        {...register("image", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg", "webp"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Image Preview</Form.Label>

                  {typeof getValues("image") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IMG_URL + getValues("image")}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    )
                  )}
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Social Links</Form.Label>

                    <Select
                      isMulti
                      options={socialLinks}
                      value={selectedSocials}
                      onChange={(selected) =>
                        setSelectedSocials(selected || [])
                      }
                      placeholder="Select Social Links"
                    />
                  </Form.Group>
                </div>
              </Col>

              {selectedSocials?.map((item) => (
                <Col md={6} key={item.value}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <Form.Label>{item.label} URL</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder={`Enter ${item.label} URL`}
                        value={socialUrls[item.value] || ""}
                        onChange={(e) =>
                          setSocialUrls((prev) => ({
                            ...prev,
                            [item.value]: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </div>
                </Col>
              ))}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
